"use client"
import Icon from '@ant-design/icons';
import type { GetProps } from 'antd';

type CustomIconComponentProps = GetProps<typeof Icon>;

const ArrowLeftSvg = () => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.828 11.0002H20V13.0002H7.828L13.192 18.3642L11.778 19.7782L4 12.0002L11.778 4.22217L13.192 5.63617L7.828 11.0002Z" fill="currentColor" />
  </svg>

)

const ArrowLeftIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={ArrowLeftSvg} {...props} />
);

export default ArrowLeftIcon